module.exports = __webpack_public_path__ + "fonts/AntykwaTorunska-BoldItalic.b51eb978.ttf";